import type { RiskScoreHistoryRow } from '@risksmart-app/drizzle/src/types';

export type RiskScoreChartSeries = {
  name: string;
  data: { x: string; y: number }[];
}[];

/**
 * Transform ordered `risk_score_audit` rows into the two-series shape
 * `LineChartWidget` consumes — one line for residual, one for inherent score.
 * Rows are plotted as raw points (no bucketing); points with a null score are
 * dropped from that series so the line only connects real values. A series
 * with no points is omitted entirely so the legend/axis stays clean.
 */
export const buildRiskScoreSeries = (
  rows: RiskScoreHistoryRow[],
  labels: { residual: string; inherent: string }
): RiskScoreChartSeries =>
  (
    [
      { name: labels.residual, key: 'ResidualScore' },
      { name: labels.inherent, key: 'InherentScore' },
    ] as const
  )
    .map(({ name, key }) => ({
      name,
      data: rows
        .filter((row) => row[key] !== null && row[key] !== undefined)
        .map((row) => ({ x: row.ModifiedAtTimestamp, y: row[key] as number })),
    }))
    .filter((series) => series.data.length > 0);
